import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import AzCarousel from '~/components/_next/molecules/AzCarousel.vue';
import AzAdviceCard from '~/components/_next/molecules/AzAdviceCard.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'RelatedAdvicesOrganism',
  props: {
    relatedAdvices: null,
    vertical: {
      type: Boolean
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var route = useRoute();
    var _useNuxt2App = useNuxt2App(),
      $trackers = _useNuxt2App.$trackers,
      i18n = _useNuxt2App.i18n;
    var relatedAdvicesTitle = computed(function () {
      var _props$relatedAdvices;
      return i18n.tc('related.advices', (_props$relatedAdvices = props.relatedAdvices) === null || _props$relatedAdvices === void 0 ? void 0 : _props$relatedAdvices.length);
    });
    var cleanAdvices = computed(function () {
      return props.relatedAdvices.map(function (advice) {
        return advice !== null && advice !== void 0 && advice.fields ? advice.fields : advice;
      });
    });
    function getAdviceCover(advice) {
      var _advice$mainImage, _advice$mainImage2, _advice$mainImage2$fi, _advice$mainImage2$fi2, _advice$mainImage3;
      return (_advice$mainImage = advice.mainImage) !== null && _advice$mainImage !== void 0 && _advice$mainImage.fields ? (_advice$mainImage2 = advice.mainImage) === null || _advice$mainImage2 === void 0 ? void 0 : (_advice$mainImage2$fi = _advice$mainImage2.fields) === null || _advice$mainImage2$fi === void 0 ? void 0 : (_advice$mainImage2$fi2 = _advice$mainImage2$fi.file) === null || _advice$mainImage2$fi2 === void 0 ? void 0 : _advice$mainImage2$fi2.url : advice === null || advice === void 0 ? void 0 : (_advice$mainImage3 = advice.mainImage) === null || _advice$mainImage3 === void 0 ? void 0 : _advice$mainImage3.url;
    }
    function getAdviceCategory(advice) {
      var _advice$parentAdviceL, _advice$parentAdviceL2, _advice$parentAdviceL3, _advice$parentAdviceL4;
      return (_advice$parentAdviceL = advice.parentAdviceListingPage) !== null && _advice$parentAdviceL !== void 0 && _advice$parentAdviceL.fields ? (_advice$parentAdviceL2 = advice.parentAdviceListingPage) === null || _advice$parentAdviceL2 === void 0 ? void 0 : (_advice$parentAdviceL3 = _advice$parentAdviceL2.fields) === null || _advice$parentAdviceL3 === void 0 ? void 0 : _advice$parentAdviceL3.title : advice === null || advice === void 0 ? void 0 : (_advice$parentAdviceL4 = advice.parentAdviceListingPage) === null || _advice$parentAdviceL4 === void 0 ? void 0 : _advice$parentAdviceL4.title;
    }
    function pushGtmClickEvent(advice) {
      $trackers.gtm.trackAdviceCard(getAdviceCategory(advice), advice.title, route.fullPath);
    }
    return {
      __sfc: true,
      route: route,
      $trackers: $trackers,
      i18n: i18n,
      props: props,
      relatedAdvicesTitle: relatedAdvicesTitle,
      cleanAdvices: cleanAdvices,
      getAdviceCover: getAdviceCover,
      getAdviceCategory: getAdviceCategory,
      pushGtmClickEvent: pushGtmClickEvent,
      AzCarousel: AzCarousel,
      AzAdviceCard: AzAdviceCard
    };
  }
});